import gql from 'graphql-tag';

import integrationThreadBodyFragment from '../fragments/integrationThreadBodyFragment';

export default gql`
  query integrationThreadBody(
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    integrationThreadBody(
      integrationID: $integrationID
      remoteID: $remoteID
    ) {
      ...integrationThreadBodyFragment
    }
  }
  ${integrationThreadBodyFragment}
`;
